export default __webpack_public_path__ + "static/media/project-assign-shaded.de743011.png";